import jquery from 'jquery';
window.$=window.jQuery=jquery;


// import { createApp } from 'vue';
// window.vueMixins={
//   priceFormatter: {
//     methods: {
//       formatPrice(price) {
//         return ((price || 0)*1).toFixed(2)+" RSD";
//       },
//     },
//   },
// };
//
// var VueComponents = {};
// let vueComponentList = [
//   require.context(".", false, /.+\.vue$/),
// ];
//
//
// (function() {
//   var vueEls=document.querySelectorAll("[vue-dyn]");
//   for(var i=0;i<vueEls.length;i++) {
//     var vueEl=vueEls[i];
//     vueEl.attributes.removeNamedItem("vue-dyn");
//     var app=createApp({});
//     for(let vueComponentListItem of vueComponentList)
//       for(let key of vueComponentListItem.keys()) {
//         let actualKey=key.replace(/\.vue|.*\//g, "");
//         let actualComponent=vueComponentListItem(key).default;
//         VueComponents[actualKey]=actualComponent;
//         app.component(actualKey, actualComponent);
//       }
//     app.mount(vueEl);
//   }
// })();

import htmljs from './htmljs';
htmljs();
